import React from "react";
import ParallaxSection from "../components/parallax";
import FretVizPrivacyPolicy from "../components/fretviz-privacy-policy";
import Carousel from "../components/carousel";

function FretVizPage() {
  const slides = [
    <img
      src="/app_images/fretviz/01.png"
      alt="Overview"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/02.png"
      alt="Hover Chords"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/03.png"
      alt="Scales"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/04.png"
      alt="Tunings"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/05.png"
      alt="Modes"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/06.png"
      alt="Color Sets"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/07.png"
      alt="Color Picker"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/fretviz/08.png"
      alt="Options"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
  ];
  return (
    <>
      <ParallaxSection className="product-hero">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "2rem",
          }}
        >
          <img
            src="/app_images/fretviz/logo.png"
            alt="FretViz Logo"
            style={{ width: "80px", height: "80px", objectFit: "contain" }}
          />
          <div>
            <h1>FretViz</h1>
            <p>Master the Guitar with Visual Clarity</p>
          </div>
          <img
            src="/app_images/fretviz/logo.png"
            alt="FretViz Logo"
            style={{ width: "80px", height: "80px", objectFit: "contain" }}
          />
        </div>
      </ParallaxSection>
      <div className="product-content">
        <Carousel slides={slides} />
        <div className="product-description" style={{ margin: "2rem 0" }}>
          <p>
            FretViz is the ultimate tool for guitarists looking to deepen their
            understanding of notes, chords, and scales through powerful visual
            learning. Whether you're just starting out or refining your
            technique, this app transforms your fretboard into a vibrant,
            interactive learning space.
          </p>
        </div>
        <div className="product-features">
          <div className="product-feature">
            <h3>🎸 Visualize Notes, Chords & Scales</h3>
            <p>
              Instantly map out any scale or chord in any key across the entire
              fretboard. Learn to recognize shapes, patterns, and relationships
              between notes and intervals.
            </p>
          </div>
          <div className="product-feature">
            <h3>🎼 Scale & Mode Selector</h3>
            <p>
              From major and minor to exotic modes and scales, easily switch
              between them to expand your musical vocabulary and creativity.
            </p>
          </div>
          <div className="product-feature">
            <h3>🌈 Customizable Color Schemes</h3>
            <p>
              Enhance your memorization process with vivid, color-coded notes
              and intervals. Choose from preset themes or create your own color
              combination.
            </p>
          </div>
          <div className="product-feature">
            <h3>🎵 Flexible Note Display Options</h3>
            <p>
              Toggle between showing note names, scale intervals, or both —
              perfect for learning theory, memorizing fretboard positions, or
              improving improvisation.
            </p>
          </div>
          <div className="product-feature">
            <h3>🎸 Alternate Tunings</h3>
            <p>
              Go beyond standard tuning with support for alternate tunings.
              Whether you're playing in Drop D, Open G, DADGAD, or half-step
              down, FretViz adapts to your setup.
            </p>
          </div>
          <div className="product-feature">
            <h3>🔄 Right- & Left-Handed Views</h3>
            <p>
              Tailor the interface to your playing style with full support for
              both right-handed and left-handed guitarists.
            </p>
          </div>
          <div className="product-feature">
            <h3>🧠 Persistent Settings</h3>
            <p>
              Your preferences matter. FretViz automatically saves your settings
              — scale, tuning, display mode, orientation, and color scheme — so
              every time you open the app, you're right where you left off. No
              need to reconfigure each session.
            </p>
          </div>
        </div>
        <div className="product-description" style={{ margin: "2rem 0" }}>
          <p>
            Whether you're visualizing arpeggios, jamming in Dorian, or
            mastering fretboard positions in alternate tunings, FretViz is your
            go-to guitar learning companion.
          </p>
        </div>
        <div className="product-download">
          <h3>Download Now</h3>
          <a
            href="https://apps.apple.com/us/app/fretviz/id6751173531"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/app_images/app_store_badge.png"
              alt="App Store"
              style={{ width: "250px", height: "auto" }}
            />
          </a>{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.woolworth_software.fretviz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/app_images/google_play_badge.png"
              alt="Google Play"
              style={{ width: "278px", height: "auto" }}
            />
          </a>
        </div>
        <div className="product-privacy-policy">
          <FretVizPrivacyPolicy />
        </div>
      </div>
    </>
  );
}

export default FretVizPage;
